import styled from "styled-components";

export const Wrapper = styled.div`
  border: 1px solid #e8f1ff;
  border-radius: 12px;
  align-self: stretch;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  [aria-selected="false"] {
    opacity: 50%;
  };
  padding-top: 24px;  
`;